module.exports = __webpack_public_path__ + "static/media/enabledStartIcon.da4788d6.svg";